import React from "react";

const IconSettings = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        d="M19.213 4.493l2.895 5.014-2.159 1.588a8.076 8.076 0 0 1 0 1.81l2.159 1.588-2.895 5.014-2.455-1.075a7.992 7.992 0 0 1-1.567.906L14.895 22h-5.79l-.296-2.662a7.992 7.992 0 0 1-1.567-.906l-2.455 1.075-2.895-5.014 2.159-1.588a8.076 8.076 0 0 1 0-1.81L1.892 9.507l2.895-5.014 2.455 1.075a7.992 7.992 0 0 1 1.567-.906L9.105 2h5.79l.296 2.662a7.992 7.992 0 0 1 1.567.906l2.455-1.075zm-.837 2.55l-1.952.855-.478-.418a5.992 5.992 0 0 0-2.005-1.16l-.601-.205L13.105 4h-2.21l-.235 2.115-.6.205a5.992 5.992 0 0 0-2.006 1.16l-.478.418-1.952-.855L4.52 8.957l1.715 1.261-.122.622a6.035 6.035 0 0 0 0 2.32l.122.622-1.715 1.261 1.105 1.914 1.952-.855.478.418a5.992 5.992 0 0 0 2.005 1.16l.601.205.235 2.115h2.21l.235-2.115.6-.205a5.992 5.992 0 0 0 2.006-1.16l.478-.418 1.952.855 1.105-1.914-1.715-1.261.122-.622a6.035 6.035 0 0 0 0-2.32l-.122-.622 1.715-1.261-1.105-1.914zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default IconSettings;
